<button mat-button class="open-filters-button" (click)="open()" aria-haspopup="dialog">
  <span class="button-content-wrapper">
    <img class="filter-carrot" src="/assets/icons/filter-expand.svg" alt="" />
    <span class="placeholder">{{ "label.placeholder.moreFilters" | translate | async }}</span>
    <vue-number-indicator
      [number]="selectedFiltersCount"
    ></vue-number-indicator>
  </span>
</button>
